export default "__VITE_ASSET__CZcx3G7w__"